export default "__VITE_ASSET__Dvr7g6Xx__"